import {
  DEFAULT_BASE_PRICE,
  DEFAULT_FREE_TRIAL,
  DEFAULT_PRICE,
  DEFAULT_PRICING_EXPERIMENT,
} from '@src/components/Modals/PaymentModal/checkout'
import { PricingType } from '@src/state/site/constants'

export const pricingJsonParse = (pricingJson: string) => {
  try {
    const data = (typeof pricingJson === 'string'
      ? JSON.parse(pricingJson as string)
      : pricingJson) as PricingType
    const freeTrial = data?.freeTrial ?? DEFAULT_FREE_TRIAL
    const price = data?.price ?? DEFAULT_PRICE
    const pricingExperiment = data?.pricingExperiment ?? DEFAULT_PRICING_EXPERIMENT
    const updatedBasePrice = data?.basePrice ?? DEFAULT_BASE_PRICE
    return {
      freeTrial,
      price,
      pricingExperiment,
      basePrice: updatedBasePrice,
    }
  } catch (error) {
    return {
      freeTrial: DEFAULT_FREE_TRIAL,
      price: DEFAULT_PRICE,
      pricingExperiment: DEFAULT_PRICING_EXPERIMENT,
      basePrice: DEFAULT_BASE_PRICE,
    } as PricingType
  }
}



// WEBPACK FOOTER //
// ./src/utils/pricingJsonParse.ts